module.exports = __webpack_public_path__ + "static/media/default-avatar.d4f7e4b4.png";